import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Avatar, Button } from 'antd';
import { useCookies } from 'react-cookie';
import * as querystring from 'querystring';
import Link from 'antd/es/typography/Link';
import { useConnection } from '@sezenta/connection';
import { useNavigate, useParams } from 'react-router-dom';
import { environment } from '../environments/environment';

enum ScreenType {
  Loading,
  Failed,
  NotRegistered,
  RegFailed,
}

export default function GoogleLogin() {
  const [cookie, _, removeCookie] = useCookies(['sociallogin', 'redirect']);
  const connection = useConnection();
  const navigate = useNavigate();
  const { code, scope, authuser, prompt } = useParams();
  const [screen, setScreen] = useState<ScreenType>(ScreenType.Loading);
  const [user, setUser] = useState<any>();
  const firstTime = useRef<boolean>(true);

  const onRegister = useCallback(
    async (user: any) => {
      try {
        setScreen(ScreenType.Loading);
        const response = await connection.post('auth/verify-email', {
          email: decodeURIComponent(user.email),
          otp: user.otp,
        });
        if (response.data.status === 'Invalid') {
          setScreen(ScreenType.RegFailed);
          return;
        }
        connection.login(response.data.accessToken, response.data.refreshToken);
        if (cookie.redirect) {
          navigate('/choose-preference');
        } else {
          navigate(
            `/choose-preference?${querystring.stringify({
              redirect: cookie.redirect,
            })}`,
          );
        }
      } catch (error: any) {
        setScreen(ScreenType.RegFailed);
      }
    },
    [connection, cookie.redirect, navigate],
  );

  useEffect(() => {
    if (!firstTime.current) {
      return;
    }
    firstTime.current = false;
    // const code = code;
    // const scope = searchParams.get('scope');
    // const authuser = searchParams.get('authuser');
    // const prompt = searchParams.get('prompt');
    // const redirect = cookie.redirect ?? '/';
    // removeCookie('redirect', { path: '/', domain: environment.cookieDomain });
    connection
      .get('auth/google/redirect', {
        params: {
          code,
          scope,
          authuser,
          prompt,
        },
      })
      .then((res) => {
        console.log(res.data);
        const user = connection.login(
          res.data.accessToken,
          res.data.refreshToken,
        );
      })
      .catch((err) => {
        if (err.response?.data?.email) {
          if (cookie.sociallogin === 'register') {
            removeCookie('sociallogin');
            onRegister(err.response.data).then();
          } else {
            setScreen(ScreenType.NotRegistered);
            setUser(err.response.data);
          }
        } else {
          setScreen(ScreenType.Failed);
        }
      });
  }, [
    authuser,
    code,
    connection,
    cookie.redirect,
    cookie.sociallogin,
    onRegister,
    prompt,
    removeCookie,
    scope,
  ]);

  if (screen === ScreenType.Failed || screen === ScreenType.RegFailed) {
    return (
      <div className="w-full flex justify-center items-center py-80">
        <div className="h-full flex flex-col justify-center items-center whitespace-nowrap">
          <h2>
            {screen === ScreenType.Failed
              ? 'Login Failed!'
              : 'Registration Failed'}
          </h2>
          <p>Please try again or try with another login method.</p>
          <Link
            href={`/login?${
              cookie.redirect
                ? querystring.stringify({ redirect: cookie.redirect })
                : ''
            }`}
          >
            <Button type="link" icon={<i className="icon-left" />}>
              Back to Login
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center items-center py-80">
      <div className="h-full flex flex-col justify-center items-center whitespace-nowrap gap-4">
        <div className="flex flex-col items-center ">
          <h2 className="text-primary">Not Registered!</h2>
          <p>You have not registered in Big Value Box</p>
        </div>
        {/*<div className="flex gap-2">*/}
        {/*  <Avatar size="large" src={user.picture} />*/}
        {/*  <div className="flex flex-col">*/}
        {/*    <div>*/}
        {/*      {user.firstName} {user.lastName}*/}
        {/*    </div>*/}
        {/*    <div className="text-sm text-gray-500">{user.email}</div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        {/*<Button*/}
        {/*  onClick={() => onRegister(user)}*/}
        {/*  type="primary"*/}
        {/*  className="w-full max-w-[300px]"*/}
        {/*>*/}
        {/*  Register Now!*/}
        {/*</Button>*/}
        <Link
          href={`/login?${
            cookie.redirect
              ? querystring.stringify({ redirect: cookie.redirect })
              : ''
          }`}
        >
          <Button type="link" icon={<i className="icon-left" />}>
            Back to Login
          </Button>
        </Link>
      </div>
    </div>
  );
}
